import * as angular from 'angular';
import { DefinitionsService } from './definitions.service';
import { IPromise } from 'angular';

export interface IImageData {
    dataUri: string;
    imageSize: {
        width: number;
        height: number;
    };
    size: number;
    error: string;
}

export class BlobService {
    static $inject = ['$q', 'definitionsService', '$translate'];

    constructor(
        private $q: ng.IQService,
        private definitionsService: DefinitionsService,
        private $translate: angular.translate.ITranslateService,
        private retailerServiceUrl: string,
    ) { }

    dataUriToBlob(dataUri: string) {
        var strings = dataUri.split(',');
        if (strings.length === 2) {
            var binary = atob(strings[1]);
            var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: mimeString });
        } else {
            return null;
        }
    }

    getDataImageByUrl(url: string): IPromise<IImageData> {
        let $translate = this.$translate;
        let dataImage: IImageData = {
            dataUri: null,
            imageSize: {
                height: null,
                width: null
            },
            size: null,
            error: null
        };
        let deferred = this.$q.defer<IImageData>();
        if (url && this.definitionsService.regexUrl.test(url)) {

            var xhr = new XMLHttpRequest();
            xhr.onload = () => {
                var reader = new FileReader();
                reader.onloadend = () => {
                    var img = new Image;
                    img.onload = function () {
                        dataImage.dataUri = reader.result;
                        dataImage.imageSize = {
                            width: img.width,
                            height: img.height
                        };
                        dataImage.size = reader.result.length;
                        deferred.resolve(dataImage);
                    };
                    img.onerror = () => {
                        let reason = $translate.instant('failed_to_download_image_fro_web_resource');
                        deferred.reject(reason);
                    };
                    img.src = reader.result;
                };

                reader.readAsDataURL(xhr.response);
            };
            xhr.onerror = function (e: ErrorEvent) {
                let reason = $translate.instant('failed_to_download_image_fro_web_resource');
                deferred.reject(reason);
            };
            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.send();

        } else {
            dataImage.error = $translate.instant('not_recognized_as_url');
            deferred.resolve(dataImage);
        }
        return deferred.promise;
    }
}

angular
    .module('app.common')
    .service('blobService', BlobService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/blob.service.ts